import React, { useState, useEffect } from "react"
import { Link } from "gatsby-plugin-react-i18next"

const Category = ({ category, location, child }) => {
  const [isOpen, setIsOpen] = useState(true)
  const [pageSlug, setPageSlug] = useState("")
  useEffect(() => {
    if (location) {
      const pSlug = location.pathname.split("/").reverse()
      console.log(pSlug[1])
      setPageSlug(pSlug[1])
    } else {
      return
    }
  }, [location])

  if (category.children || category.items.length > 0) {
    return (
      <li
        className={`category ${
          category.slug
        } mb-2 py-3 w-full transition-all ease-in-out ${
          child ? "" : "border-gray-400 border-dashed border-b"
        } w-full first-of-type:pt-6`}
      >
        <button
          className={`transition-all text-[14pt] font-[600]  ease-in-out flex text-dark-sage break-words text-left ${
            child ? " pl-4 text-[13pt]" : "pl-2 "
          } hover:text-black`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={`transition w-5 h-5 mt-[.3em] mr-1 ${
              isOpen ? "rotate-270" : "-rotate-90"
            }`}
          >
            <path
              fillRule="evenodd"
              d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
              clipRule="evenodd"
            />
          </svg>

          {category.name}
        </button>
        <>
          {isOpen ? (
            <>
              {category.items.length > 0 && (
                <ul className="w-full">
                  {category.items.map((categoryItem, index) => (
                    <li key={index} className="w-full">
                      <Link
                        to={`/${categoryItem.fields.slug}`}
                        className={`block w-full ${
                          child ? "pl-10" : "pl-8"
                        } py-3 hover:bg-light-green text-sm hover:text-darker-sage hover:shadow-md ${
                          pageSlug === categoryItem.fields.slug
                            ? "bg-ddp-green text-white shadow-lg"
                            : "text-dark-sage"
                        } ${pageSlug} ${categoryItem.fields.slug}`}
                      >
                        {categoryItem.frontmatter.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
              {category.children ? (
                <ul className="list">
                  {category.children.map((child, index) => (
                    <Category
                      category={child}
                      key={index}
                      child={true}
                      location={location}
                    />
                  ))}
                </ul>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </>
      </li>
    )
  }
}

export default Category
